import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody,Input,FormGroup } from 'reactstrap';


import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { baridiPay, viaPay } from '../../../slices/modalSlice';


class ViaPayModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
          selectedRadio: ""
        };

      }

    toogleClose = () =>this.props.dispatch(viaPay());
    
     

    selectMethod = () =>{
      let radios = document.querySelectorAll('Input[name="method"]');
      let selectedValue;
            for (const radio of radios) {
                if (radio.checked) {
                    selectedValue = radio.id;
                    this.setState ({
                      selectedRadio : selectedValue
                    })
                    break;
                }
            }
            if ((this.state.selectedRadio) === "baridi") {
              this.toogleClose();
                this.props.dispatch(baridiPay())
              
            } 
          
            
      
          
    }
    render() {
      
        return (
            <div>
              <Modal isOpen={this.props.viaPay} toggle={this.toogleClose} contentClassName="reserveModal" centered={true} >
                   <ModalHeader className="modalHeader contactPayHeader d-flex justify-content-center align-items-center" ><center className="text-center contactPayTxt">Paiement via Ghurfaty</center></ModalHeader>
                   <ModalBody className="d-flex flex-column justify-content-center align-items-center">
                   <p className="text-center contactPayInfos">Veuillez choisir un moyen de paiement SVP</p> 
                   <FormGroup className="d-flex flex-column align-items-center">
                        <div className="payRadios mb-3">
                      
                            <div className="row align-items-center payMethItems">
                             
                                    <div className="col-4 d-flex align-items-center">
                                      <Input  type="radio" name="method" id="baridi" />{' '}
                                  
                                      <img   className="payMethImg" src="/imgs/resrervationIcons/baridi.png" alt="payment"/>
                                      </div>
                                      <div className="col-8 payMethTxt">
                                       <p className="radioTitle">CCP / Baridimob</p>
                                       <p className="radioExp">Payez par virement CCP/ BaridiMob et télécharger un scan du talon de virement</p>
                                      </div>
                                   </div>
                             
                              
                                   <div className="row align-items-center payMethItems">
                                    <div className="col-4 d-flex align-items-center">
                                      <Input   type="radio" name="method" id="dahabia" />{' '}
                                   
                                      
                                      <img  className="payMethImg" src="/imgs/resrervationIcons/dahabia.png" alt="payment"/>
                                      </div>
                                      <div className="col-8 payMethTxt">
                                       <p className="radioTitle">Carte CIB/ Edhahabia</p>
                                       <p className="radioExp">Payez avec votre carte en toute sécurité</p>
                                      </div>
                                   </div>
                                
                           
                                   <div className="row align-items-center payMethItems">
                                       <div className="col-4 d-flex align-items-center">
                                      <Input  type="radio" name="method" id="creditCard" />{' '}
                                      <img  className="payMethImg" src="/imgs/resrervationIcons/visaCard.png" alt="payment" />
                                      </div>
                                      <div className="col-8 payMethTxt">
                                       <p className="radioTitle">Carte de Crédit</p>
                                       <p className="radioExp">Payez avec votre carte Visa ou MasterCard</p>
                                      </div>
                                   </div>
                             
                                   <div className="row  align-items-center payMethItems">
                                      <div className="col-4 d-flex align-items-center">
                                        <Input  type="radio" name="method" id="paypal"/>{' '}
                                        <img   className="payMethImg" src="/imgs/resrervationIcons/paypal.png" alt="payment"/>
                                      </div>
                                      <div className="col-8 payMethTxt">
                                       <p className="radioTitle">PayPal</p>
                                       <p className="radioExp">Un seul clic, pas de panique!</p>
                                      </div>
                                   </div>
                               
                                   <div className="row align-items-center payMethItems mb-3">
                                     <div className="col-4 d-flex align-items-center">
                                      <Input type="radio" name="method" id="especes"/>{' '}
                                      
                                      <img className="payMethImg" src="/imgs/resrervationIcons/especes.png" alt="payment"/>
                                      </div>
                                      <div className="col-8 payMethTxt">
                                       <p className="radioTitle">Espèces</p>
                                       <p className="radioExp">Trouver un agent près de vous </p>
                                      </div>
                                   </div>
                               
                                   </div>   
                                   <Button onClick={this.selectMethod} className="contactPayBtns precedBtn d-flex align-items-center justify-content-between mt-3">
                                        <span></span>
                                        <span className="text-center">Suivant</span>
                                
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 14.839 29.677">
                                       <path id="Tracé_521" data-name="Tracé 521" d="M7671.4-1190l7.652,10.652L7671.4-1168.7" transform="translate(-7667.213 1194.187)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                                        </svg>
                                   </Button>
                   </FormGroup>           
                    <Button onClick={this.toogleClose} className="contactPayBtns annulerBtn d-flex justify-content-center"><span className="mr-3">Annuler</span></Button>
                   </ModalBody>
              </Modal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
    
      viaPay : state.modal.viaPay
      
    }
  }
export default withRouter(connect(mapStateToProps)(ViaPayModal));
